import FuseNavigation from '@fuse/core/FuseNavigation';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import clsx from 'clsx';
import { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { selectNavigation } from 'app/store/fuse/navigationSlice';
import { navbarCloseMobile } from '../../store/fuse/navbarSlice';
import useNetworkStatus from 'app/main/components/UseNetworkStatus';
import { t } from 'i18next';

function Navigation(props) {
	const isOnline = useNetworkStatus();
	const navigation = useSelector(state => selectNavigation(state, isOnline));
	const bottleTrackerEnabled = useSelector(
		state => state.taskBoardApp?.accountSettings?.accountSettings?.bottleTrackerEnabled === true
	);
	const theme = useTheme();
	const mdDown = useMediaQuery(theme.breakpoints.down('md'));
	const dispatch = useDispatch();

	function handleItemClick(item) {
		mdDown && dispatch(navbarCloseMobile());
	}

	return (
		<FuseNavigation
			className={clsx('navigation', props.className)}
			navigation={navigation.filter(item => item.id !== 'bottle-tracker' || bottleTrackerEnabled)}
			layout={props.layout}
			dense={props.dense}
			active={props.active}
			onItemClick={handleItemClick}
		/>
	);
}

Navigation.defaultProps = {
	layout: 'vertical'
};

export default memo(Navigation);
